/**
 * How a Super Dog is marked in the interface, and how it is explained.
 *
 * A dog rather than an asterisk. An asterisk is a pointer to a footnote, which
 * means it says nothing on its own and needs the footnote to be on screen and
 * read. The rule is called Super Dog, so the icon names it outright, and the
 * legend below the list confirms it rather than being the only way to decode it.
 *
 * One definition, because it appears on three screens: this week's games on the
 * home page, the lineup, and the scoreboard. They must not drift into three
 * different marks for the same rule.
 */
import { SUPER_DOG_SPREAD } from "./season";
import { isSuperDog } from "./gameStatus";

export const SUPER_DOG_MARK = "🐕";

export const SUPER_DOG_LEGEND =
  `Super Dog. An underdog of ${SUPER_DOG_SPREAD} or more takes no penalty for losing.`;

/**
 * Whether any of these teams is a Super Dog this week, so a list can decide
 * whether its legend has anything to explain.
 *
 * @param {string[]} slugs team slugs, as stored in a lineup
 * @param {Record<string, object>} gamesBySlug the week's games keyed by slug
 */
export const anySuperDog = (slugs, gamesBySlug) =>
  (slugs || []).some((slug) => slug && isSuperDog(gamesBySlug?.[slug], slug));
